import gql from 'graphql-tag';
import get from 'lodash/get';

export const GENDERS = {
  M: 'MALE',
  F: 'FEMALE',
  X: 'NON_BINARY',
  U: 'NOT_SPECIFIED',
};

export const COLLEGE_EVENTS_PAGE_SIZE = 10;

const ETHNICITY = {
  UK: 'UNKNOWN',
  AI: 'AMERICAN_INDIAN',
  AS: 'ASIAN',
  BA: 'BLACK',
  FI: 'FILIPINO',
  HI: 'HISPANIC',
  MR: 'MULTI_RACIAL',
  OT: 'OTHER',
  PI: 'PACIFIC_ISLANDER',
  WH: 'WHITE',
};

export const GRADE_LEVEL = {
  9: 'GRADE_9',
  10: 'GRADE_10',
  11: 'GRADE_11',
  12: 'GRADE_12',
};

export const studentProfile = (user) => {
  const gender = get(user, 'gender', 'U');
  const zipCode = get(user, 'address.zip', '');
  const state = get(user, 'address.state', '');
  const gradeLevel = get(user, 'gradeLevel', '');
  const gpa = parseFloat(get(user, 'defaultGpa', null));
  const ethnicity = get(user, 'ethnicity', 'UK');

  return {
    gender: GENDERS[gender],
    zipCode: zipCode,
    state: state,
    gradeLevel: GRADE_LEVEL[gradeLevel],
    gpa: Number.isNaN(gpa) ? undefined : gpa,
    ethnicity: ETHNICITY[ethnicity],
  };
};

const query = gql`
  query CollegeEvents($studentProfile: StudentProfile, $filter: EventSearchFilter, $sort: EventSearchSort, $first: Int, $after: String) {
    searchCollegeEvents(studentProfile: $studentProfile, filter: $filter, sort: $sort, first: $first, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          collegeEvent {
            id
            name
            timezone
            eventDateTime
            startTime
            eventEndDateTime
            endTime
            eventDescription
            registrationUrl
            registrationDeadline
            registrationDeadlineTime
            collegeEventLocation {
              name
              street
              street2
              city
              state
              zipCode {
                zipCode
              }
            }
            virtual
          }
          college {
            scid
            name
          }
          recommended
          recommendedAudienceProfile {
            id
          }
        }
      }
    }
  }
`;

export default query;
